export var NoticeTypes;
(function (NoticeTypes) {
    NoticeTypes["REPLY_TO_COMMENT"] = "rtc";
    NoticeTypes["COMMENT_LIKE"] = "cl";
    NoticeTypes["NEW_PUBLICATION"] = "np";
})(NoticeTypes || (NoticeTypes = {}));
